import React from "react";
import PropTypes from "prop-types";

import {BookizonAppManager} from "../../../index";
import {FuxCarousel} from "../../../components/BaseComponents/FuxCarousel/FuxCarousel";

export function DashboardCarouselBanner(props) {
    const banners = props.negozio?.banner_adv || [];

    function openBannerCtaInApp(cta_url) {
        const url = new URL(cta_url);
        url.searchParams.append('utm_source', 'app');
        BookizonAppManager.openInAppBrowser(`${url.href}`);
    }

    return (
        <React.Fragment>
            <FuxCarousel
                className={"__disable-swipe"}
                overlappingIndicators={true}
                autoscroll={3000}
                items={
                    banners.map((b, i) => {
                        const onClick = _ => openBannerCtaInApp(b.cta_url);
                        return <div key={b.banner_id} className={"carousel-item active"} onClick={onClick}>
                            <div className={'position-relative'} style={{background: 'white'}}>
                                <img src={`${b.mobile_image_url}`} className={'img-fluid d-block mx-auto'} alt={"..."}/>
                            </div>
                        </div>
                    })
                }
            />
        </React.Fragment>
    )
}

DashboardCarouselBanner.propTypes = {
    negozio: PropTypes.object
}
